import ArchitectureDesignForm from "../component/ArchitectureDesignForm";

const CorporateArchitectureDesignEdit = () => {
  return <ArchitectureDesignForm isEditMode={true} />;
};

export default CorporateArchitectureDesignEdit;
